import type { FilterConfig } from '#types/config/components/filter'
import type { RecursivePartial } from '#types/utils'

export default {
  brandClasses: {
    base: 'rounded-sm b-brand-1',
    selected: 'bg-brand-10 c-white  h-8',
    unselected: 'bg-white c-grey-10  h-8'
  }
} satisfies RecursivePartial<FilterConfig['option']['tileExpanded']>
